var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "select-input",
      class: {
        "select-input--disabled": _vm.disabled,
        "select-input--focused": _vm.focused,
        "select-input--error": _vm.error,
        "select-input--empty": !_vm.options.length,
        "select-input--no-selection": !_vm.value,
      },
    },
    [
      _c(
        "div",
        { staticClass: "select-input__wrapper" },
        [
          _c("FormInput", {
            attrs: {
              value: _vm.computedValue,
              label: _vm.label,
              "label-option": _vm.labelOption,
              placeholder: _vm.label,
              readonly: "",
              error: _vm.error,
            },
          }),
          _vm._v(" "),
          _c(
            "select",
            {
              ref: "input",
              staticClass: "select-input__select",
              attrs: {
                id: _vm.id,
                name: _vm.name,
                required: _vm.required,
                disabled: _vm.disabled || _vm.readonly,
              },
              domProps: { value: _vm.value },
              on: { change: _vm.onInput, focus: _vm.onFocus, blur: _vm.onBlur },
            },
            [
              _c("option", {
                attrs: { value: "", disabled: "" },
                domProps: { innerHTML: _vm._s(_vm.label) },
              }),
              _vm._v(" "),
              _vm._l(_vm.options, function (option) {
                return _c("option", {
                  key: option.value,
                  attrs: { disabled: option.disabled },
                  domProps: {
                    value: option.value,
                    innerHTML: _vm._s(option.label || option.value),
                  },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hint
        ? _c("span", {
            staticClass: "form-input__hint | form-input-hint",
            domProps: { innerHTML: _vm._s(_vm.hint) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error && _vm.errorMessage
        ? _c("span", {
            staticClass: "form-input__error | form-input-error",
            domProps: { innerHTML: _vm._s(_vm.errorMessage) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.successMessage
        ? _c("span", {
            staticClass: "form-input__success | form-input-success",
            domProps: { innerHTML: _vm._s(_vm.successMessage) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }